const MtrTableViewOutline={
    "name": "mtr-table-view",
    "theme": "outline",
    "icon": {
        "tag": "svg",
        "attrs": {
            "viewBox": "0 0 24 24",
            "fill": "none",
            "xmlns": "http://www.w3.org/2000/svg"
        },
        "children": [
            {},
            {
                "tag": "path",
                "attrs": {
                    "d": "M5 6H19",
                    "stroke": "currentColor",
                    "stroke-width": "2",
                    "stroke-miterlimit": "10",
                    "stroke-linecap": "round"
                }
            },
            {},
            {
                "tag": "path",
                "attrs": {
                    "d": "M5 12H19",
                    "stroke": "currentColor",
                    "stroke-width": "2",
                    "stroke-miterlimit": "10",
                    "stroke-linecap": "round"
                }
            },
            {},
            {
                "tag": "path",
                "attrs": {
                    "d": "M5 18H19",
                    "stroke": "currentColor",
                    "stroke-width": "2",
                    "stroke-miterlimit": "10",
                    "stroke-linecap": "round"
                }
            },
            {}
        ]
    }
};
export default MtrTableViewOutline;